import { Box, Flex, Link, Text } from "@chakra-ui/react";
import React from "react";
import * as AF from "src/types/formTemplate";

type Props = {
  sections: AF.Sections<AF.WithId>;
};

export const SectionNavigation: React.FC<Props> = ({ sections }) => {
  if (sections.length === 0) {
    return null;
  }

  const handleScrollToSection = (sectionId: string) => {
    const element = document.getElementById(`section-${sectionId}`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Flex
      borderRadius="md"
      border="1px solid"
      borderColor="gray.300"
      direction="column"
      padding={3}
      gap={3}
      minWidth="15rem"
    >
      <Text fontWeight="600">Sections</Text>
      {sections.map((section, index) => {
        if (!section) return null;
        return (
          <Box key={index}>
            <Link
              fontSize="0.875rem"
              onClick={() => handleScrollToSection(section.id)}
              color="primary.500"
              cursor="pointer"
              wordBreak="break-word"
              lineHeight="1.4"
            >
              {section.title}
            </Link>
          </Box>
        );
      })}
    </Flex>
  );
};
